module.exports = "/React/dist/7b927025d719ee81d83384f5d49107ea.png";